import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'

import { firstValueFrom } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class HttpService {
  /* 
  Se ha marcado "HttpClient" como "readonly", porque se inyecta en el constructor 
  y no se vuelve a modificar. Esto es una buena práctica.
  */
  constructor(private readonly _http: HttpClient) { }

  async executeHttpPostMethod(urlString: string, bodyDictionary: any) {
    console.log(urlString)
    try {
      const result = await firstValueFrom(this._http.post<any>(urlString, bodyDictionary));
      return result;
    } catch (error) {
      return { resultOk: false, error };
    }
  }
  
}
